export default {
    datas:{
        'ErrorMsg': null,
        //重定向
        'RedirectURL': null,
        //获取结果
        'Success': true,
        'AccessType': 'TEXT',
        //订单号
        'ResNo': 'R20005160000050685',
        'Source': 'WEB',
        //已经分配的房间
        'AssignInfos': [
            {
    
                'Building': {
                    'Floors': [],
                    'HallID': 'A',
                    'HallName': '主楼|01'
                },
                //知否已入住
                'IsCheckIn': false,
                'LiveGuests': [],
                //分配的房间
                'Room': {
                    'Building': 'A',
                    'ChamberNumber': '8202',
                    'ChamberType': 'SQR',
                    'Hobby': [
                        '15㎡-20㎡',
                        '朝东',
                        '窗朝小区',
                        '独立空调',
                        '吸烟房',
                        '阳光房（窗户朝阳）'
                    ],
                    'IsAssign': true,
                    //房间坐标
                    'LatLngBounds': [
                        {
                            'Lat': 31.202242686094603,
                            'Lng': 121.41176337913589
                        },
                        {
                            'Lat': 31.202277959587406,
                            'Lng': 121.41179958895759
                        },
                        {
                            'Lat': 31.202260896395366,
                            'Lng': 121.41182222009616
                        },
                        {
                            'Lat': 31.20222576628446,
                            'Lng': 121.41178601027445
                        }
                    ],
                    //房间所属楼层
                    'Storey': '02'
                },
                //楼层
                'Storey': {
                    'Coordinate': '31.202036988392485|121.41144881132368,31.202391888833077|121.41207895277648',
                    'FloorID': '02',
                    'FloorName': '02层|02',
                    'Rooms': []
                }
            },{
                'Building': {
                    'Floors': [],
                    'HallID': 'B',
                    'HallName': '主楼|02'
                },
                'IsCheckIn': false,
                'LiveGuests': [],
                'Room': {
                    'Building': 'B',
                    'ChamberNumber': '8202',
                    'ChamberType': 'SQR',
                    'Hobby': [
                        '15㎡-20㎡',
                        '朝东',
                        '窗朝小区',
                        '独立空调',
                        '吸烟房',
                        '阳光房（窗户朝阳）'
                    ],
                    'IsAssign': true,
                    'LatLngBounds': [
                        {
                            'Lat': 31.212242686094603,
                            'Lng': 121.41176337913589
                        },
                        {
                            'Lat': 31.212277959587406,
                            'Lng': 121.41179958895759
                        },
                        {
                            'Lat': 31.212260896395366,
                            'Lng': 121.41182222009616
                        },
                        {
                            'Lat': 31.21222576628446,
                            'Lng': 121.41178601027445
                        }
                    ],
                    'Storey': '02'
                },
                'Storey': {
                    'Coordinate': '31.212036988392485|121.41144881132368,31.212391888833077|121.41207895277648',
                    'FloorID': '02',
                    'FloorName': '02层|02',
                    'Rooms': []
                }
            }
        ],
        'BookingCount': 2,
        'ChamberNos': null,
        'ElapsedTime': 0,
        //楼宇
        'Halls': [
            {
                //楼层
                'Floors': [
                    {
                        'FloorID': '02',
                        'FloorName': '02层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        //房间
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8202',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '朝东',
                                    '窗朝小区',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': true,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202242686094603,
                                        'Lng': 121.41176337913589
                                    },
                                    {
                                        'Lat': 31.202277959587406,
                                        'Lng': 121.41179958895759
                                    },
                                    {
                                        'Lat': 31.202260896395366,
                                        'Lng': 121.41182222009616
                                    },
                                    {
                                        'Lat': 31.20222576628446,
                                        'Lng': 121.41178601027445
                                    }
                                ],
                                'Storey': '02'
                            }
                        ]
                    },
                    {
                        'FloorID': '03',
                        'FloorName': '03层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8305',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.202241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.20222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.202189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '03'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8306',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.202207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.202171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.20218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '03'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8308',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.202187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.202170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.202135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '03'
                            }
                        ]
                    },
                    {
                        'FloorID': '05',
                        'FloorName': '05层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8505',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.202241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.20222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.202189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '05'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8506',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.202207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.202171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.20218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '05'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8508',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.202187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.202170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.202135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '05'
                            }
                        ]
                    },
                    {
                        'FloorID': '06',
                        'FloorName': '06层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8605',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.202241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.20222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.202189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '06'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8606',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.202207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.202171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.20218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '06'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8608',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.202187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.202170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.202135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '06'
                            }
                        ]
                    },
                    {
                        'FloorID': '07',
                        'FloorName': '07层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8702',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202242686094603,
                                        'Lng': 121.41176337913589
                                    },
                                    {
                                        'Lat': 31.202277959587406,
                                        'Lng': 121.41179958895759
                                    },
                                    {
                                        'Lat': 31.202260896395366,
                                        'Lng': 121.41182222009616
                                    },
                                    {
                                        'Lat': 31.20222576628446,
                                        'Lng': 121.41178601027445
                                    }
                                ],
                                'Storey': '07'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '8708',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.202187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.202170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.202135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '07'
                            }
                        ]
                    },
                    {
                        'FloorID': '08',
                        'FloorName': '08层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '8805',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.202241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.20222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.202189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '08'
                            }
                        ]
                    },
                    {
                        'FloorID': '09',
                        'FloorName': '09层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '10',
                        'FloorName': '10层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1002',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.20226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.20222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.202243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '10'
                            }
                        ]
                    },
                    {
                        'FloorID': '11',
                        'FloorName': '11层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '12',
                        'FloorName': '12层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1205',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202240891323907,
                                        'Lng': 121.41184864197498
                                    },
                                    {
                                        'Lat': 31.202225118619307,
                                        'Lng': 121.41186976437098
                                    },
                                    {
                                        'Lat': 31.20218984510681,
                                        'Lng': 121.41183456037766
                                    },
                                    {
                                        'Lat': 31.202205904593804,
                                        'Lng': 121.41181276742941
                                    }
                                ],
                                'Storey': '12'
                            }
                        ]
                    },
                    {
                        'FloorID': '15',
                        'FloorName': '15层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '16',
                        'FloorName': '16层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1602',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.20226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.20222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.202243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '16'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '1606',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202187837670742,
                                        'Lng': 121.41183590148216
                                    },
                                    {
                                        'Lat': 31.20222282440751,
                                        'Lng': 121.41187144075161
                                    },
                                    {
                                        'Lat': 31.20220676492339,
                                        'Lng': 121.41189390425211
                                    },
                                    {
                                        'Lat': 31.202172638510582,
                                        'Lng': 121.41185769443041
                                    }
                                ],
                                'Storey': '16'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '1608',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202152564144324,
                                        'Lng': 121.41188451652056
                                    },
                                    {
                                        'Lat': 31.202187550894145,
                                        'Lng': 121.41191938523775
                                    },
                                    {
                                        'Lat': 31.20217091785078,
                                        'Lng': 121.4119425192905
                                    },
                                    {
                                        'Lat': 31.20213564431805,
                                        'Lng': 121.41190664474493
                                    }
                                ],
                                'Storey': '16'
                            }
                        ]
                    },
                    {
                        'FloorID': '17',
                        'FloorName': '17层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1702',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.20226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.20222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.202243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '17'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '1706',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202187837670742,
                                        'Lng': 121.41183590148216
                                    },
                                    {
                                        'Lat': 31.20222282440751,
                                        'Lng': 121.41187144075161
                                    },
                                    {
                                        'Lat': 31.20220676492339,
                                        'Lng': 121.41189390425211
                                    },
                                    {
                                        'Lat': 31.202172638510582,
                                        'Lng': 121.41185769443041
                                    }
                                ],
                                'Storey': '17'
                            }
                        ]
                    },
                    {
                        'FloorID': '18',
                        'FloorName': '18层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1802',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20227630820212,
                                        'Lng': 121.41179981738901
                                    },
                                    {
                                        'Lat': 31.20226082227982,
                                        'Lng': 121.41182261616564
                                    },
                                    {
                                        'Lat': 31.202224688451196,
                                        'Lng': 121.41178707689619
                                    },
                                    {
                                        'Lat': 31.20224304214363,
                                        'Lng': 121.41176394284344
                                    }
                                ],
                                'Storey': '18'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '1805',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202241034708706,
                                        'Lng': 121.4118484324274
                                    },
                                    {
                                        'Lat': 31.20222526200413,
                                        'Lng': 121.41186921954727
                                    },
                                    {
                                        'Lat': 31.202189988491686,
                                        'Lng': 121.41183300972557
                                    },
                                    {
                                        'Lat': 31.202206047978656,
                                        'Lng': 121.41181188732958
                                    }
                                ],
                                'Storey': '18'
                            },
                            {
                                'Building': 'A',
                                'ChamberNumber': '1808',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.20215184719921,
                                        'Lng': 121.41188564807749
                                    },
                                    {
                                        'Lat': 31.20218712072588,
                                        'Lng': 121.4119208520708
                                    },
                                    {
                                        'Lat': 31.202169914129144,
                                        'Lng': 121.41194398612356
                                    },
                                    {
                                        'Lat': 31.20213464059606,
                                        'Lng': 121.41190744102573
                                    }
                                ],
                                'Storey': '18'
                            }
                        ]
                    },
                    {
                        'FloorID': '19',
                        'FloorName': '19层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.202036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.202391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'A',
                                'ChamberNumber': '1905',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.202241034708706,
                                        'Lng': 121.4118484324274
                                    },
                                    {
                                        'Lat': 31.20222526200413,
                                        'Lng': 121.41186921954727
                                    },
                                    {
                                        'Lat': 31.202189988491686,
                                        'Lng': 121.41183300972557
                                    },
                                    {
                                        'Lat': 31.202206047978656,
                                        'Lng': 121.41181188732958
                                    }
                                ],
                                'Storey': '19'
                            }
                        ]
                    }
                ],
                'HallID': 'A',
                'HallName': '主楼',
                //楼宇的坐标
                'LatLngBounds': [
                    {
                        'Lat': 31.202036988392486,
                        'Lng': 121.41144881132368
                    },
                    {
                        'Lat': 31.202391888833077,
                        'Lng': 121.41207895277648
                    }
                ]
            },{
                'Floors': [
                    {
                        'FloorID': '02',
                        'FloorName': '02层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8202',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '朝东',
                                    '窗朝小区',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': true,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212242686094603,
                                        'Lng': 121.41176337913589
                                    },
                                    {
                                        'Lat': 31.212277959587406,
                                        'Lng': 121.41179958895759
                                    },
                                    {
                                        'Lat': 31.212260896395366,
                                        'Lng': 121.41182222009616
                                    },
                                    {
                                        'Lat': 31.21222576628446,
                                        'Lng': 121.41178601027445
                                    }
                                ],
                                'Storey': '02'
                            }
                        ]
                    },
                    {
                        'FloorID': '03',
                        'FloorName': '03层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8305',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.212241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.21222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.212189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '03'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8306',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.212207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.212171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.21218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '03'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8308',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.212187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.212170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.212135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '03'
                            }
                        ]
                    },
                    {
                        'FloorID': '05',
                        'FloorName': '05层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8505',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.212241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.21222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.212189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '05'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8506',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.212207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.212171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.21218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '05'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8508',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.212187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.212170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.212135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '05'
                            }
                        ]
                    },
                    {
                        'FloorID': '06',
                        'FloorName': '06层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8605',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.212241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.21222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.212189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '06'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8606',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21222347207269,
                                        'Lng': 121.41187267915325
                                    },
                                    {
                                        'Lat': 31.212207125812123,
                                        'Lng': 121.41189497501568
                                    },
                                    {
                                        'Lat': 31.212171708904597,
                                        'Lng': 121.41185842991786
                                    },
                                    {
                                        'Lat': 31.21218805517127,
                                        'Lng': 121.41183663696961
                                    }
                                ],
                                'Storey': '06'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8608',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.212187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.212170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.212135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '06'
                            }
                        ]
                    },
                    {
                        'FloorID': '07',
                        'FloorName': '07层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8702',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212242686094603,
                                        'Lng': 121.41176337913589
                                    },
                                    {
                                        'Lat': 31.212277959587406,
                                        'Lng': 121.41179958895759
                                    },
                                    {
                                        'Lat': 31.212260896395366,
                                        'Lng': 121.41182222009616
                                    },
                                    {
                                        'Lat': 31.21222576628446,
                                        'Lng': 121.41178601027445
                                    }
                                ],
                                'Storey': '07'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '8708',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212151777926524,
                                        'Lng': 121.41188491673188
                                    },
                                    {
                                        'Lat': 31.212187338229816,
                                        'Lng': 121.41192129419164
                                    },
                                    {
                                        'Lat': 31.212170418409754,
                                        'Lng': 121.41194409296827
                                    },
                                    {
                                        'Lat': 31.212135144876873,
                                        'Lng': 121.41190738023238
                                    }
                                ],
                                'Storey': '07'
                            }
                        ]
                    },
                    {
                        'FloorID': '08',
                        'FloorName': '08层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '8805',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '吸烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212205691929503,
                                        'Lng': 121.41181249708848
                                    },
                                    {
                                        'Lat': 31.212241395600723,
                                        'Lng': 121.41184870691018
                                    },
                                    {
                                        'Lat': 31.21222504934329,
                                        'Lng': 121.41187049985842
                                    },
                                    {
                                        'Lat': 31.212189632442483,
                                        'Lng': 121.4118339547606
                                    }
                                ],
                                'Storey': '08'
                            }
                        ]
                    },
                    {
                        'FloorID': '09',
                        'FloorName': '09层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '10',
                        'FloorName': '10层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1002',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.21226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.21222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.212243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '10'
                            }
                        ]
                    },
                    {
                        'FloorID': '11',
                        'FloorName': '11层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '12',
                        'FloorName': '12层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1205',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212240891323907,
                                        'Lng': 121.41184864197498
                                    },
                                    {
                                        'Lat': 31.212225118619307,
                                        'Lng': 121.41186976437098
                                    },
                                    {
                                        'Lat': 31.21218984510681,
                                        'Lng': 121.41183456037766
                                    },
                                    {
                                        'Lat': 31.212205904593804,
                                        'Lng': 121.41181276742941
                                    }
                                ],
                                'Storey': '12'
                            }
                        ]
                    },
                    {
                        'FloorID': '15',
                        'FloorName': '15层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': []
                    },
                    {
                        'FloorID': '16',
                        'FloorName': '16层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1602',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.21226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.21222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.212243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '16'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '1606',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212187837670742,
                                        'Lng': 121.41183590148216
                                    },
                                    {
                                        'Lat': 31.21222282440751,
                                        'Lng': 121.41187144075161
                                    },
                                    {
                                        'Lat': 31.21220676492339,
                                        'Lng': 121.41189390425211
                                    },
                                    {
                                        'Lat': 31.212172638510582,
                                        'Lng': 121.41185769443041
                                    }
                                ],
                                'Storey': '16'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '1608',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212152564144324,
                                        'Lng': 121.41188451652056
                                    },
                                    {
                                        'Lat': 31.212187550894145,
                                        'Lng': 121.41191938523775
                                    },
                                    {
                                        'Lat': 31.21217091785078,
                                        'Lng': 121.4119425192905
                                    },
                                    {
                                        'Lat': 31.21213564431805,
                                        'Lng': 121.41190664474493
                                    }
                                ],
                                'Storey': '16'
                            }
                        ]
                    },
                    {
                        'FloorID': '17',
                        'FloorName': '17层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1702',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21227788547524,
                                        'Lng': 121.41179935638434
                                    },
                                    {
                                        'Lat': 31.21226067889502,
                                        'Lng': 121.41182081405645
                                    },
                                    {
                                        'Lat': 31.21222655250165,
                                        'Lng': 121.41178594533926
                                    },
                                    {
                                        'Lat': 31.212243185535245,
                                        'Lng': 121.41176381711489
                                    }
                                ],
                                'Storey': '17'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '1706',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212187837670742,
                                        'Lng': 121.41183590148216
                                    },
                                    {
                                        'Lat': 31.21222282440751,
                                        'Lng': 121.41187144075161
                                    },
                                    {
                                        'Lat': 31.21220676492339,
                                        'Lng': 121.41189390425211
                                    },
                                    {
                                        'Lat': 31.212172638510582,
                                        'Lng': 121.41185769443041
                                    }
                                ],
                                'Storey': '17'
                            }
                        ]
                    },
                    {
                        'FloorID': '18',
                        'FloorName': '18层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1802',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21227630820212,
                                        'Lng': 121.41179981738901
                                    },
                                    {
                                        'Lat': 31.21226082227982,
                                        'Lng': 121.41182261616564
                                    },
                                    {
                                        'Lat': 31.212224688451196,
                                        'Lng': 121.41178707689619
                                    },
                                    {
                                        'Lat': 31.21224304214363,
                                        'Lng': 121.41176394284344
                                    }
                                ],
                                'Storey': '18'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '1805',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212241034708706,
                                        'Lng': 121.4118484324274
                                    },
                                    {
                                        'Lat': 31.21222526200413,
                                        'Lng': 121.41186921954727
                                    },
                                    {
                                        'Lat': 31.212189988491686,
                                        'Lng': 121.41183300972557
                                    },
                                    {
                                        'Lat': 31.212206047978656,
                                        'Lng': 121.41181188732958
                                    }
                                ],
                                'Storey': '18'
                            },
                            {
                                'Building': 'B',
                                'ChamberNumber': '1808',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.21215184719921,
                                        'Lng': 121.41188564807749
                                    },
                                    {
                                        'Lat': 31.21218712072588,
                                        'Lng': 121.4119208520708
                                    },
                                    {
                                        'Lat': 31.212169914129144,
                                        'Lng': 121.41194398612356
                                    },
                                    {
                                        'Lat': 31.21213464059606,
                                        'Lng': 121.41190744102573
                                    }
                                ],
                                'Storey': '18'
                            }
                        ]
                    },
                    {
                        'FloorID': '19',
                        'FloorName': '19层',
                        'LatLngBounds': [
                            {
                                'Lat': 31.212036988392486,
                                'Lng': 121.41144881132368
                            },
                            {
                                'Lat': 31.212391888833077,
                                'Lng': 121.41207895277648
                            }
                        ],
                        'Rooms': [
                            {
                                'Building': 'B',
                                'ChamberNumber': '1905',
                                'ChamberType': 'SQR',
                                'Hobby': [
                                    '15㎡-20㎡',
                                    '窗朝小区',
                                    '窗户朝南',
                                    '独立空调',
                                    '无烟房',
                                    '阳光房（窗户朝阳）'
                                ],
                                'IsAssign': false,
                                'LatLngBounds': [
                                    {
                                        'Lat': 31.212241034708706,
                                        'Lng': 121.4118484324274
                                    },
                                    {
                                        'Lat': 31.21222526200413,
                                        'Lng': 121.41186921954727
                                    },
                                    {
                                        'Lat': 31.212189988491686,
                                        'Lng': 121.41183300972557
                                    },
                                    {
                                        'Lat': 31.212206047978656,
                                        'Lng': 121.41181188732958
                                    }
                                ],
                                'Storey': '19'
                            }
                        ]
                    }
                ],
                'HallID': 'B',
                'HallName': '主楼',
                'LatLngBounds': [
                    {
                        'Lat': 31.212036988392486,
                        'Lng': 121.41144881132368
                    },
                    {
                        'Lat': 31.212391888833077,
                        'Lng': 121.41207895277648
                    }
                ]
            }
        ],
    
        'LatLng': null,
        //楼层图片服务器
        'ResourceDomain': 'http://localhost:2968/',
        //
        'ReturnURL': null,
        
        //订单状态
        'Status': 'R',
        //可选房间总数
        'UsableChamberCount': 24
    }
}



// WEBPACK FOOTER //
// ./src/views/self-helpSelectRoom/mapData.js